
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/ProjectFilter/ProjectFilter.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./ProjectFilter.html');
        
        var script = require('./ProjectFilter.ts').default;
        module.exports = require('./ProjectFilter.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    